import { render } from "./RouteForm.vue?vue&type=template&id=6dbbfb20&scoped=true"
import script from "./RouteForm.vue?vue&type=script&lang=js"
export * from "./RouteForm.vue?vue&type=script&lang=js"

import "./RouteForm.vue?vue&type=style&index=0&id=6dbbfb20&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6dbbfb20"]])

export default __exports__